import * as actionType from "./bookingActionType";
import { readBookingDraft } from "./bookingAction";

const initialState = {
  isLoading: false,
  booking: null,
  bookingConfirm: false,
  bookings: [],
  bookingAvailable: false,
  prices: [],
  pricesLoading: false,
  coupon: {},
  canceled: false,
  savedProperty: readBookingDraft(),
  eligibleCoupons: [],
  eligibleCouponsLoading: false,
  eligibleComplimentaryAddOns: [],
  eligibleComplimentaryAddOnsLoading: false,
};

export const bookingReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionType.CREATE_BOOKING:
            return {
                ...state,
                isLoading: true,
                bookingConfirm: false,
            };
        case actionType.CREATE_BOOKING_FAILURE:
            return {
                ...state,
                isLoading: false
            };
        case actionType.CREATE_BOOKING_SUCCESS:
            return {
                ...state,
                isLoading: false,
                booking: action.payload ? action.payload.data : {}
            };
        case actionType.CREATE_BOOKING_HDFC:
            return {
                ...state,
                isLoading: true
            };
        case actionType.CREATE_BOOKING_HDFC_FAILURE:
            return {
                ...state,
                isLoading: false
            };
        case actionType.CREATE_BOOKING_HDFC_SUCCESS:
            return {
                ...state,
                isLoading: false,
                booking: action.payload ? action.payload.data : {}
            };
        case actionType.CANCEL_BOOKING:
            return {
                ...state,
                isLoading: true,
                canceled: false,
            };
        case actionType.CANCEL_BOOKING_FAILURE:
            return {
                ...state,
                isLoading: false
            };
        case actionType.CANCEL_BOOKING_SUCCESS:
            return {
                ...state,
                isLoading: false,
                canceled: true
            };
        case actionType.APPLY_COUPON:
            return {
                ...state,
                isLoading: true
            };
        case actionType.APPLY_COUPON_FAILURE:
            return {
                ...state,
                isLoading: false
            };
        case actionType.APPLY_COUPON_SUCCESS:
            return {
                ...state,
                isLoading: false,
                coupon: action.payload ? action.payload.data.data : {}
            };
        case actionType.REMOVE_COUPON:
            return {
                ...state,
                coupon: {}
            };
        case actionType.CONFIRM_BOOKING:
            return {
                ...state,
                isLoading: true,
                bookingConfirm: false
            };
        case actionType.CONFIRM_BOOKING_FAILURE:
            return {
                ...state,
                isLoading: false
            };
        case actionType.CONFIRM_BOOKING_SUCCESS:
            return {
                ...state,
                isLoading: false,
                bookingConfirm: false,
                booking: action.payload?.data?.booking
                    ? { ...state.booking, ...action.payload.data.booking }
                    : state.booking,
            };
        case actionType.CHECK_BOOKING:
            return {
                ...state,
                isLoading: true,
                bookingAvailable: false
            };
        case actionType.CHECK_BOOKING_FAILURE:
            return {
                ...state,
                isLoading: false
            };
        case actionType.CHECK_BOOKING_SUCCESS:
            return {
                ...state,
                isLoading: false,
                bookingAvailable: true
            };
        case actionType.FETCH_BOOKING:
            return {
                ...state,
                isLoading: true
            };
        case actionType.FETCH_BOOKING_FAILURE:
            return {
                ...state,
                isLoading: false
            };
        case actionType.FETCH_BOOKING_SUCCESS:
            return {
                ...state,
                isLoading: false,
                bookings: action.payload ? action.payload.data : false
            };
        case actionType.FETCH_BOOKING_BY_ID:
            return {
                ...state,
                isLoading: true,
                booking: action.payload?.keepExistingBooking ? state.booking : null,
            };
        case actionType.FETCH_BOOKING_BY_ID_FAILURE:
            return {
                ...state,
                isLoading: false
            };
        case actionType.FETCH_BOOKING_BY_ID_SUCCESS:
            return {
                ...state,
                isLoading: false,
                booking: action.payload ? action.payload.data : null
            };
        case actionType.GET_PRICES:
            return {
                ...state,
                isLoading: true,
                pricesLoading: true,
            };
        case actionType.GET_PRICES_FAILURE:
            return {
                ...state,
                isLoading: false,
                pricesLoading: false,
            };
        case actionType.GET_PRICES_SUCCESS:
            return {
                ...state,
                isLoading: false,
                pricesLoading: false,
                prices: action.payload ? action.payload.data : []
            };
        case actionType.SAVE_PROPERTY_FOR_NEXT:
            return {
                ...state,
                isLoading: false,
                savedProperty: action.payload ? action.payload.data : null
            };
        case actionType.REMOVE_PROPERTY_FOR_NEXT:
            return {
                ...state,
                isLoading: false,
                savedProperty: null,
                booking: null,
                bookingConfirm: false,
                bookingAvailable: false
            };
        case actionType.RESET_BOOKING_CHECKOUT:
            return {
                ...state,
                isLoading: false,
                bookingConfirm: false,
                bookingAvailable: false,
                eligibleComplimentaryAddOns: [],
            };
        case actionType.GET_ELIGIBLE_COUPONS:
            return { ...state, eligibleCouponsLoading: true };
        case actionType.GET_ELIGIBLE_COUPONS_FAILURE:
            return { ...state, eligibleCouponsLoading: false };
        case actionType.GET_ELIGIBLE_COUPONS_SUCCESS:
            return {
                ...state,
                eligibleCouponsLoading: false,
                eligibleCoupons: action.payload?.data || [],
            };
        case actionType.GET_ELIGIBLE_COMPLIMENTARY_ADDONS:
            return { ...state, eligibleComplimentaryAddOnsLoading: true };
        case actionType.GET_ELIGIBLE_COMPLIMENTARY_ADDONS_FAILURE:
            return {
                ...state,
                eligibleComplimentaryAddOnsLoading: false,
                eligibleComplimentaryAddOns: [],
            };
        case actionType.GET_ELIGIBLE_COMPLIMENTARY_ADDONS_SUCCESS:
            return {
                ...state,
                eligibleComplimentaryAddOnsLoading: false,
                eligibleComplimentaryAddOns: action.payload?.data || [],
            };
        case actionType.CLEAR_ELIGIBLE_COMPLIMENTARY_ADDONS:
            return {
                ...state,
                eligibleComplimentaryAddOns: [],
                eligibleComplimentaryAddOnsLoading: false,
            };
        default:
            return state;
    }
}